<template>
  <!-- <SignUpProgress/> -->
  <b-container fluid>
    <b-row class="no-gutters">
      <b-col sm="12" lg="6">
        <div class="vcenter">
          <div>
            <div class="signup-header">
              <img class="logo" src="/static/images/logos/brandly/brandly-logo-dark.svg">
              <h1>Start ordering business cards like a pro.</h1>
              <h2>NO CREDIT CARD REQUIRED</h2>
            </div>
            <div class="wrapper">
              <SignUpForm/>
            </div>
            <div class="wrapper" id="social">
              <h2>OR SIGNUP USING</h2>
              <div>
                <GoogleCircle @login="onGoogleLogin"></GoogleCircle>
                <LinkedInCircle @login="onLinkedInLogin"></LinkedInCircle>
              </div>
            </div>
            <div class="has-account">
              <p>
                Already have an account?
                <a href="https://www.brandly.com/signin">&nbsp; Log in here</a>
              </p>
            </div>
          </div>
        </div>
      </b-col>

      <b-col class="d-none d-lg-block" lg="6">
        <div class="team">
          <div class="team">
            <div class="red-zone">
              <blockquote>
                <q>Brandly lets new team members easily join our account, edit their info, and self-order their cards in minutes. As a manager, it's one less thing for me to worry about</q>
                <div class="testimonial">
                  <span class="circle"></span>
                  <cite>Amrit Singh, Cofounder of GoodHands</cite>
                </div>
              </blockquote>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: mapGetters(["loginError"]),
  methods: {
    ...mapActions(["socialAuth"]),
    async onGoogleLogin(userinfo) {
      console.log("google user:", userinfo);
      await this.socialAuth({
        provider: "google",
        access_token: userinfo.auth.access_token
      });
      this.redirect();
    },
    async onFacebookLogin() {
      // not implemented
    },
    async onLinkedInLogin(info) {
      console.log("linkedin info:", info);
      await this.socialAuth(info);
      this.redirect();
    },
    redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/colors";

.row.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.row.no-gutters > [class^="col-"],
.row.no-gutters > [class*=" col-"] {
  padding-right: 0;
  padding-left: 0;
}

.container-fluid {
  height: 100vh;
  background: $frost-0; //background color
  width: 100%;
  padding: 0;
  margin: 0;
}

.logo {
  width: 150px;
  height: 35px;
  margin-bottom: 2em;
}

.signup-header {
  max-width: 400px;
  text-align: center;
  margin: 0 auto;
}

.team {
  position: relative;
  background-image: url("/static/images/signup/signup.jpg");
  height: 100vh;
  background-size: cover;
  background-position: center;
}

.red-zone {
  position: absolute;
  background: rgba(202, 29, 46, 0.9);
  height: 50%;
  width: 100%;
  bottom: 0;
  padding: 0 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

blockquote {
  font-family: Proxima Nova;
  font-weight: 300;
  margin: 60px auto;
  padding: 10px 0 10px 70px;
  position: relative;
  max-width: 450px;

  q {
    color: $white;
    display: block;
    font-size: 18px;
    line-height: 1.25em;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
    quotes: "“" "”";

    &::before {
      color: rgba(255, 255, 255, 0.5);
      content: open-quote;
      font-family: Georgia, "Times New Roman", Times, serif;
      font-size: 120px;
      font-weight: bold;
      line-height: 120px;
      left: 0;
      top: 0;
      position: absolute;
      width: 90px;
    }

    &::after {
      content: close-quote;
    }
  }

  cite {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 1.25em;
    letter-spacing: 0;
    color: $white;
    padding: 1.5em;
  }
}

.testimonial {
  display: flex;
  justify-content: flex-start;
}

.circle {
  display: block;
  margin: 0;
  background-image: url("/static/images/signup/amrit.png");
  background-size: cover;
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.vcenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  > div {
    display: block;
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 300px;
  margin: 0 auto;
}

#social {
  padding-top: 2em;
  width: 300px;

  > div {
    display: flex;
    justify-content: space-around;

    width: 100px;
    margin: 0 auto;
  }
}

.sign-in-btn {
  width: 100%;
  color: $gray-1;
  line-height: 20px;
  border-color: $gray-1;
}

h1 {
  font-size: 2rem;
}

h2 {
  color: $gray-1;
  text-transform: uppercase;
  font-weight: normal !important;
  font-size: 0.8rem;
  letter-spacing: 0.1rem;
  margin: 0;
  padding-bottom: 1em;
}

h3 {
  color: $gray-1;
  font-weight: 600 !important;
  font-size: 16px;
  font-style: italic;
  letter-spacing: 0.1rem;
}

.form-wrapper {
  margin: 0 auto;
}

.has-account {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  font-size: 16px;
  color: $gray-1;
  margin: 2em auto 0 auto;
  & a {
    color: $red; //link color
  }
}

p {
  margin-top: 1em;
  margin-bottom: 0;
}

/* small device */

@media (max-width: 480px) {
  .logo {
    width: 125px;
    margin-bottom: 0;
  }
  h1 {
    font-size: 1.5rem;
    max-width: 300px;
    margin: 1em auto;
  }
  h2 {
    font-size: 0.7rem;
    padding-bottom: 1.5em;
  }
  #social {
    padding: 0;
  }
  .has-account {
    font-size: 14px;
    margin: 0 auto;
  }
}

/* Landscape phone - iPhone X */
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation: landscape) {
  .container-fluid {
    height: 100%;
    min-height: 812px;
  }
  .vcenter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 812px;
    > div {
      display: block;
      margin: 1em auto;
    }
  }
}

.content {
  ul {
    list-style-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB1WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOkNvbXByZXNzaW9uPjE8L3RpZmY6Q29tcHJlc3Npb24+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDx0aWZmOlBob3RvbWV0cmljSW50ZXJwcmV0YXRpb24+MjwvdGlmZjpQaG90b21ldHJpY0ludGVycHJldGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KAtiABQAAAMBJREFUKBVj/A8EDCQCJhLVg5WzYNP0+/oduDCrpgqcDWOgaPr/7TvDh4x6hj97LsHkGZgNFRj4ptcysMhJw8UYkf30Ib+F4ffqI3BJGAOkUWjrDBiXAe4nkC3YNIBU/j3/gAHZyXBNfx4+hZtEiAHXxCKPcDPRmhi5OBlYQ22wqgf5CTkU4TaBVPPWZoFDC1kno7QAOPRQxJBDDybx68wlhj93HjKwqMgzsGqpMoBcgQxQghxZAh8bxXn4FCLLAQBnoDmhM1SUdgAAAABJRU5ErkJggg==");
    margin-top: 3em;
    margin-left: 1em;
    @media screen and (max-width: 831px) {
      margin: 3em auto 0 auto;
      min-width: 300px;
      width: 70%;
    }
  }
  li {
    margin-bottom: 2em;
    line-height: 1.3em;
    a {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homepage/SignUp.vue